import React, { memo, useCallback, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UploadProvocation } from 'reactApp/ui/Datalist/UploadProvocation/UploadProvocation';
import type { IProvocation } from 'reactApp/ui/Datalist/UploadProvocation/UploadProvocation.types';
import { Footer } from 'reactApp/ui/Footer/Footer';

interface IProps {
    itemsCount: number;
    hideUpload?: boolean;
}

export const ExtraBlocks = memo(({ itemsCount, hideUpload }: IProps) => {
    const provocationRef = useRef<IProvocation | null>(null);
    const [isAbsolutePos, setIsAbsolutePos] = useState(true);
    const storage = useSelector(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const showUploadProvocation = isHome && !hideUpload;

    const onProvocationChecked = useCallback(
        (checked: boolean) => {
            if (checked && provocationRef.current?.canShow()) {
                setIsAbsolutePos(false);
            } else {
                setIsAbsolutePos(true);
            }
        },
        [setIsAbsolutePos, provocationRef]
    );

    return (
        <>
            {showUploadProvocation && <UploadProvocation ref={provocationRef} itemsCount={itemsCount} onChecked={onProvocationChecked} />}
            <Footer
                isAbsolutePos={isAbsolutePos}
                right={isAbsolutePos ? 8 : undefined}
                bottom={isAbsolutePos ? 3 : undefined}
                storage={storage}
            />
        </>
    );
});

ExtraBlocks.displayName = 'ExtraBlocks';
